module.exports = __webpack_public_path__ + "static/media/health-program-bg.b955c740.png";